<template>
  <div class="hello">
    <h2>{{title}} <span v-if="currentAuthor">{{currentAuthor}}</span></h2>
    
    <div id="content" class="container">
      <div id="header" class="row">
        <div class="col-8">
          <input
            id="search"
            v-on:input="filterQuotes"
            type="search"
            placeholder="Buscar"
            class="form-control bg-none border-1">
        </div>
        <div class="col-2">
          <h1  v-if="quotes.length>0" class="p-10"><span class="badge alert-warning" >NO: {{quotes.length}}</span></h1>
        </div>
        <div class="col-2">
          <h1  v-if="ocupados.length>0" class="p-10"><span class="badge alert-primary">ASISTIO: {{ocupados.length}}</span></h1>
        </div>
      </div>

      <div class="row">

        <div id="quotes" class="col-9 anyClass">
          <div class="row " >
            <div v-for="quote in quotes" class="quote col-5 border border-secondary b-radius" v-bind:key="quote">
              <div class="quote-text">{{ quote.no }} - {{ quote.nombre }} </div>
              <div>
                <span class="author">- {{ quote.mesa}}</span>
                <span class="source badge alert-info" v-if="quote.mesa_no != ''">M:{{ quote.mesa_no }}</span>
                <span class="badge alert-primary" v-if="quote.ocupado==1" >Asistio <a class="btn btn-warning btn-sm " v-on:click="updateRow(quote.no,0)">Uncheck</a></span>
                <a class="btn btn-sm btn-success" v-else  v-on:click="updateRow(quote.no,1)">Check</a>
              </div>
            </div>
          </div>
        </div>

        <div id="sidebar" class="col-3 anyClass">
          <div class="row " >
            <div class="col-12 mb10" >
              <button id="" class="btn btn-info" v-on:click="reset">
                Reset
              </button>
              <button id="refresh" class="btn btn-success" v-on:click="refresh">
                Refresh
              </button>
            </div>
          </div>
          
          
          <div id="authors">
            <h2>
              Mesas
            </h2>
            <div class="list-group" >
              <button type="button" class="list-group-item list-group-item-action " v-for="(author, i) in authors"   v-on:click="selectAuthor" :data="author" v-bind:key="author">
                {{ author }} ( {{tags[i]}})
              </button>
            </div>
          </div>
         
          

        </div>

      </div>

    </div>
  </div>
</template>
<style>
      * {
        font-family: 'Noto Sans HK', sans-serif;
      }
      body {
        padding-bottom: 128px;
      }
      #header {
        margin: 16px 0px 16px 0px;
      }
      #search {
        padding: 22px 16px 22px 16px;
      }
      .quote {
        margin-bottom: 16px;
        padding: 10px 10px 24px 10px;
        border-bottom: 1px dotted #CECECE;
        margin-left: 1rem;
      }
      .quote-text {
        font-size: 1.2em;
      }
      .author {
        margin-left: 24px;
        font-weight: bold;
        color: #676767;
      }
      .source {
        font-size: 0.8em;
        color: #676767;
      }
      .tag-container {
        text-align: right;
      }
      .tag {
        border-radius: 12px;
        background-color: #17A2B8;
        color: #FFFFFF;
        padding: 5px 10px;
        margin-left: 5px;
        font-size: 0.8em;
      }

      #sidebar {
        padding: 12px;
      }

      .menu-item {
        cursor: pointer;
      }
      .menu-item:hover {
        color: #4477AA;
      }
      #reset-filter {
        cursor: pointer;
        margin-bottom: 24px;
      }
      #reset-filter:hover {
        color: #4477AA;
      }
      .b-radius {
        border-radius: 8px;;
      }

      .anyClass {
  height:650px;
  overflow-y: scroll;
}

    </style>
<script>
import axios from "axios";

      var gsheet_url = 'https://sheets.googleapis.com/v4/spreadsheets/15ZNwSQB1njoH1cbJC0R_UaVNtGAg8ci8cXwjvM39frw/values/sheet?key=AIzaSyBG7NvxTIIFhw_TrVjmmHDPYECnlRpX1R0';
      // $url = 'https://sheets.googleapis.com/v4/spreadsheets/1z3d96akWk_1D6ckBjMQco255anu3q_wDT-j_g8qws4g/values/'.$this->_sheet.'?key=AIzaSyDuv1LtgOqEhzwxg4HUusHsFQvyXK5h6qA';
       
   // Global variables to hold the data from the spreadsheet
      var quoteList = [];
      var authorList = [];
      var tagList = [];
const { GoogleSpreadsheet } = require('google-spreadsheet');
const creds = require('@/client_secret.json');
export default {
  components:{
  },
  name: 'HelloWorld',
  data(){
        return{
          quotes: quoteList,
          quoteList: [],
          authors: authorList,
          tags: tagList,
          ocupados:[],
          title: 'Disponibilidad',
          currentAuthor: '',

        }
  },
  methods: {
    async updateRow(no,value) {
				const doc = new GoogleSpreadsheet('15ZNwSQB1njoH1cbJC0R_UaVNtGAg8ci8cXwjvM39frw');
				await doc.useServiceAccountAuth(creds);
				await doc.loadInfo(); 
        var title = 0;
        const sheet = doc.sheetsByIndex[title]
				const rows = await sheet.getRows(); // can pass in { limit, offset }
        var row = no -1;
        // read/write row values
        console.log(rows[row].NOMBRE); // 'Larry Page'
        console.log(rows[row].OCUPADO); // 'Larry Page'
        rows[row].OCUPADO = value; // update a value
        
        try {
          await rows[row].save(); // save updates
          this.showSuccessToast('Registro actualizado');
          console.log(quoteList[row]);
          quoteList[row].ocupado = value;
          console.log(quoteList[row]);
        } catch (err) {
          // TODO (developer) - Handle exception
          this.showErrorToast('Error');
        }
				
			},
    filterQuotes: function(event) {
      var query = event.target.value;
      this.filterAccion(query);
      
    },
    filterAccion: function(query){
      var ocupados = [];
      this.ocupados = [];
      // Reset filter if query is empty string
      if (query.length == 0) {
        this.quotes = quoteList;
      }

      // Do nothing if query is too short
      if (query.length < 3) return;
      
      var filtered = [];
      query = query.toLowerCase();
      console.log(query);

      // Search in quote, author and source
      quoteList.forEach(function(value) {
        var quote = value.nombre.toLowerCase();
        var author = value.mesa.toLowerCase();
        var source = value.mesa_no.toLowerCase();
        if (
          (quote.search(query) >= 0) ||
          (author.search(query) >= 0) ||
          (source.search(query) >= 0)) {
          filtered.push(value);
          if (value.ocupado == 1) {
            ocupados.push(value);
          }
        }
      });
      this.ocupados = ocupados;
      this.quotes = [];
      this.quotes = filtered;
    },
    parseData(entries) {
        quoteList = [];
        authorList = [];
        tagList = []; 
        var authorSet = new Set();
        var tagSet = new Set();
        var i = 0;
        entries.forEach(function(value) {
          //console.log(value);
          if(i==1){
            var entry = {
              "no": value[0],
              "lugar": value[1],
              "nombre": value[2],
              "mesa": value[3],
              "mesa_no": value[4],
              "ocupado": value[5]
            };
            authorSet.add(entry.mesa);
            tagSet.add(entry.mesa_no);
            
            quoteList.push(entry);
          }
          i= 1;
        });

        authorList = Array.from(authorSet);
         tagList = Array.from(tagSet);
        //authorList.sort();

        
        this.quotes = quoteList;
        //console.log(this.quotes);
        this.authors = authorList;
        //console.log(this.authorList);

        this.tags = tagList;
    },
    reset: function() {
      this.currentAuthor = '';
            this.quotes = quoteList;
    },
    refresh: function() {
      this.currentAuthor = '';
        axios
          .get(gsheet_url)
          .then(response => (
            this.parseData(response.data.values)
        ))
    },
    selectTag: function(event) {
      var selected = [];
      var tag = event.target.getAttribute('data');
      quoteList.forEach(function(value) {
        if (value.tags.includes(tag)) {
          selected.push(value);
        }
      });
      this.quotes = selected;
    },
    selectAuthor: function(event) {

      var selected = [];
      var ocupados = [];
      this.ocupados = [];
      var author = event.target.getAttribute('data');
      quoteList.forEach(function(value) {
        if (value.mesa == author) {
          selected.push(value);
          if (value.ocupado == 1) {
            ocupados.push(value);
          }
        }
        
      });
      
      this.quotes = selected;
      this.ocupados = ocupados;
      this.currentAuthor = author; 
      console.log('ocupados',this.ocupados);
      
    },
    selectTableNo: function(event) {

      var selected = [];
      var author = event.target.getAttribute('data');
      console.log(author);
      quoteList.forEach(function(value) {
        if (value.mesa_no == author) {
          selected.push(value);
        }
      });
      console.log('selected',selected);
      this.quotes = selected;
    },
    showSuccessToast(msg) {
      this.$toastr.s("Success", msg);
    },
    showErrorToast(msg) {
      this.$toastr.e("Error", msg);
    }

  },
  mounted () {
    this.currentAuthor='';
    axios
          .get(gsheet_url)
          .then(response => (
            this.parseData(response.data.values)
        ))
  }
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
